import React from 'react'
import DefaultDashboard from '../../../Components/Dashboard/Default'

export default function Default() {
  return (
    <div className='page-body'>
        <DefaultDashboard/>
    </div>
  )
}
